import { Component, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TotemService } from '../totem.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-new-map',
  templateUrl: './new-map.component.html',
  styleUrls: ['./new-map.component.css']
})
export class NewMapComponent implements OnInit {

  planos = [];
  menuIn = false;
  totemConfig;
  pisito;
  opcion = 'tiendas';
  idEst = 0;
  rutaalt = false;

  NombreTipoRuta = "";


  constructor(private totemService: TotemService,private location: Location,
              private activeRoute: ActivatedRoute, private router: Router ) {
    router.events.subscribe((val) => {
      const routeParams = this.activeRoute.snapshot.params;
      this.opcion = routeParams.opt;

      switch(this.opcion){
        case 'tiendas':
          this.NombreTipoRuta = "tiendas";
          break;
        case 'servicios':
          this.NombreTipoRuta = "servicios";
          break;
        case 'estacionamiento':
          this.NombreTipoRuta = "estacionamento";
          break;
      }

      if (this.opcion === 'estacionamiento') {
        this.idEst = routeParams.piid;
      }
      console.log('this.opcion', this.opcion);
    });
   }

  async ngOnInit() {
    // this.totemConfig = await this.totemService.getTotemConfig(null);
    const result = await this.totemService.getPlanos().toPromise();
    console.log('result', result);
    this.planos = result.map(piso => {
      piso.siglapiso = this.calcSiglaPiso(piso.piso_numero);
      return piso;
    });
    console.log('planos', this.planos);
  }
  desplegarInstrucciones() {
    this.menuIn = !this.menuIn;
    const manage = !this.menuIn ? 'show' : 'hide';
  }
  calcSiglaPiso(piso: number) {
    return piso >= 0 ? `p${piso.toString()}` : `b${Math.abs(piso).toString()}`;
  }
  obtenerEstacionamiento() {
    const estNombre = this.totemService.getEstacionamientoPorID(Number(this.idEst));
    return estNombre;
  }

  public goBack() {
    this.location.back();
  }
  getTranslation(key: string) {
    const word = this.totemService.getTranslation(key);
    if (word){
      return word[0].texto_descripcion;
    }
  }

  getInstructionTraslation(key: string) {
    // console.log('key instrucciones', key, key.indexOf('_'))
    if(key.indexOf('_')===-1){
      const word = this.totemService.getTranslation(key);
      if (word){
        const res = word[0].texto_descripcion ? word[0].texto_descripcion : '';
        return res.toString();
      }
    } else{
      const traduccion = key.split('_');
      const word = this.totemService.getTranslation(traduccion[0]);
      if (word){
        const res = word[0].texto_descripcion ? word[0].texto_descripcion + ' ' + traduccion[1] : '';
        return res.toString();
      }
    }
  }
  getPisoTraslation(key: string) {
    if(key.indexOf(' ')!==-1){
      
      let traduccion = key.split(' ');
      traduccion[0] = traduccion[0].toLowerCase();
      const word = this.totemService.getTranslation(traduccion[0]);
      if (word){
        const res = word[0].texto_descripcion ? word[0].texto_descripcion + ' ' + traduccion[1] : '';
        return res.toString();
      }
    }
    // return key;
  }
}
